import React from 'react';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import SystemTranslationSummary from './SystemTranslationSummary';
import Separator from '../../../core/layout/Separator';
import SystemTranslationLocaleContainer from './SystemTranslationLocaleContainer';
import SystemTranslationLocaleFormContainer from './form/SystemTranslationLocaleFormContainer';

const SystemTranslationScene = () => {
  return (
    <>
      <Breadcrumb
        crumbs={[
          {
            text: 'System Translations',
          },
        ]}
      />
      <SystemTranslationSummary />
      <Separator />
      <SystemTranslationLocaleContainer />
      <SystemTranslationLocaleFormContainer />
    </>
  );
};

export default SystemTranslationScene;
